"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConfig = void 0;
var validateConfig = function (configValidators) {
    var errors = [];
    var validateRecursively = function (innerConfigValidators, path) {
        if (path === void 0) { path = []; }
        var result = {};
        Object.entries(innerConfigValidators).forEach(function (_a) {
            var _b = __read(_a, 2), configKey = _b[0], validatorOrNested = _b[1];
            var newPath = __spreadArray(__spreadArray([], __read(path)), [configKey]);
            if (typeof validatorOrNested === 'object' && !Array.isArray(validatorOrNested)) {
                result[configKey] = validateRecursively(validatorOrNested, newPath);
            }
            else if (typeof validatorOrNested === 'function') {
                try {
                    result[configKey] = validatorOrNested();
                }
                catch (e) {
                    errors.push([newPath.join('.'), e]);
                }
            }
            else {
                result[configKey] = validatorOrNested;
            }
        });
        return result;
    };
    var validatedConfig = validateRecursively(configValidators);
    if (errors.length > 0) {
        var aggregatedErrorMsg = errors.map(function (_a) {
            var _b = __read(_a, 2), path = _b[0], error = _b[1];
            return "'" + path + "': " + error;
        }).join('\n');
        throw new Error(aggregatedErrorMsg);
    }
    return validatedConfig;
};
exports.validateConfig = validateConfig;
